var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackDefaultinline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "275C769E-13A9-4786-B2D0-1EEC52C208F8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "7-10-Drafts-Inventory",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2_07_30-Create-a-draft-from-basic",
    transform: "translate(-274.000000, -97.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "heading",
    transform: "translate(274.000000, 94.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Back/default",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 18,
    height: 18,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,9.78000017 L12.0600004,6.72000122 L13,7.66666759 L9,11.666666 L5,7.66666759 L5.93999994,6.72000122 L9,9.78000017 Z",
    id: "Shape",
    fill: "#495057",
    transform: "translate(9.000000, 9.193334) rotate(-270.000000) translate(-9.000000, -9.193334) "
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackDefaultinline);
export default __webpack_public_path__ + "static/media/back-default.inline.a5091b0ffc9d4df0242cafa4c5c81467.svg";
export { ForwardRef as ReactComponent };